import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "../../UI/Progress";

export const GoogleCallBack = (): React.JSX.Element => {
  const location = useLocation();

  useEffect(() => {
    const channel = new BroadcastChannel("google-auth-channel");
    channel.postMessage({ code:  location.search });
    channel.close();
    window.close();
  }, []);
  return <CircularProgress />;
};